import { useMutation } from "react-query";
import { LogenInstance, LotteInstance } from "../instance";
import Swal from "sweetalert2";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { addBarcodeResultState } from "../../stores/addbarcode/addBarcodeResultState";

// TODO 운송장 추가등록 API
export const useAddBarcode = (setIsLoading) => {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState); // 로그인 전역변수
  const setResult = useSetRecoilState(addBarcodeResultState); // 운송장 추가등록 입력 자동저장

  // TODO 데이터 통신
  const mutation = useMutation(
    (data) => {
      // API 리퀘스트 정보
      if (login.company === "LOGEN") {
        return LogenInstance.post("/loin", {
          api: "dvAll",
          data,
        });
      } else if (login.company === "LOTTE") {
        return LotteInstance.post("/loin", {
          api: "dvAll",
          data,
        });
      } else {
        return Promise.reject(new Error("Invalid company"));
      }
    },
    {
      // 성공 시
      onSuccess: (data) => {
        // 데이터 불러오기 성공 시
        if (data.result === "00" || data.result === "77") {
          setIsLoading(false);
          setResult(data.data[0]);
          Swal.fire({
            icon: "success",
            title: "등록 완료",
            html: `성공적으로 운송장 등록이 완료되었습니다!<br>등록 성공 : ${
              data.data[0].count || 0
            } 건<br>등록 실패 : ${data.data[0].fail || 0} 건`,
            confirmButtonText: "확인",
          });
          // 데이터 불러오기 실패 시
        } else if (data.result === "fail") {
          setIsLoading(false);
          Swal.fire({
            title: "Error!",
            icon: "error",
            text: "송장 등록에 실패했습니다. 다시 등록해주세요.",
            confirmButtonText: "확인",
          });
        }
      },
      // 실패 시
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return mutation;
};
